import { ApolloError, FetchResult } from '@apollo/client';

export default async function requestHandler<T>(fn: Promise<FetchResult<T>>) {
  let data;
  let error: string | undefined;
  try {
    const { data: response } = await fn;

    data = response;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    if (err?.message !== 'Staff has already logged in today.') {
      console.error({ err });
    }

    error = (err as ApolloError).message;
  }

  return { data, error };
}
